import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { PunchOutIntegration } from '@idealsupply/ngclient-webservice-shopping-cart';
import { ButtonNavItemData, NavItemType } from 'navigation-data';
import { NavigationListComponent } from 'navigation-ui';

@Component({
  selector: 'ideal-punchout-integration-list-view',
  imports: [NavigationListComponent],
  templateUrl: './punchout-integration-list-view.component.html',
  styleUrl: './punchout-integration-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutIntegrationListViewComponent {
  public readonly integrations = input<PunchOutIntegration[]>([]);
  public readonly customerNumber = input<string | null>(null);

  public readonly itemClicked = output<PunchOutIntegration>();

  protected readonly items = computed(() => {
    return this.integrations().map(
      (integration) =>
        ({
          type: NavItemType.Button,
          id: `punchout-integration-menu.integration-${integration.id}`,
          label: signal(integration.label ?? 'UNKNOWN'),
          heading: signal(`Vendor Selectors`),
          active: signal(false),
          hidden: signal(true),
          icon: signal(undefined),
          priority: signal(100),
          disabled: signal(false),
          onClick: (evt: Event) => {
            this.itemClicked.emit(integration);
          },
        }) as ButtonNavItemData,
    );
  });
}
